'use client';

import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import logo from '../../assets/logo.svg';

const DOC_LINKS = [
  { slug: 'appstore-connect', label: 'App Store Connect' },
  { slug: 'play-store',       label: 'Play Store' },
  { slug: 'firebase',         label: 'Firebase (Push)' },
];

export default function DocsLayout({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  return (
    <div className="flex min-h-screen bg-white">
      {/* Sidebar */}
      <aside className="w-56 flex-shrink-0 border-r border-[#d3e2fd] flex flex-col">
        {/* Brand header */}
        <div className="h-14 px-4 flex items-center gap-2 border-b border-[#d3e2fd]">
          <Link href="/" className="flex items-center gap-2">
            <Image src={logo} alt="Apporb" width={24} height={24} className="rounded-lg" />
            <div>
              <p className="text-sm font-semibold text-gray-900 leading-tight">Apporb</p>
              <p className="text-xs text-gray-400 leading-tight">Grow Your App</p>
            </div>
          </Link>
        </div>

        {/* Nav */}
        <nav className="flex-1 p-4 space-y-1">
          <Link
            href="/docs"
            className={`block text-sm px-3 py-2 rounded-lg transition-colors mb-3 ${
              pathname === '/docs'
                ? 'bg-[#e8f0fe] text-[#041e49] font-medium'
                : 'text-gray-600 hover:bg-[#f0f4ff] hover:text-[#041e49]'
            }`}
          >
            Home
          </Link>
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Setup Guides</p>
          {DOC_LINKS.map(({ slug, label }) => {
            const active = pathname === `/docs/${slug}`;
            return (
              <Link
                key={slug}
                href={`/docs/${slug}`}
                className={`block text-sm px-3 py-2 rounded-lg transition-colors ${
                  active
                    ? 'bg-[#e8f0fe] text-[#041e49] font-medium'
                    : 'text-gray-600 hover:bg-[#f0f4ff] hover:text-[#041e49]'
                }`}
              >
                {label}
              </Link>
            );
          })}
        </nav>
      </aside>

      {/* Main */}
      <div className="flex-1 flex flex-col">
        {/* Top bar */}
        <header className="h-14 border-b border-[#d3e2fd] flex items-center px-10 gap-2">
          <Image src={logo} alt="Apporb" width={20} height={20} className="rounded-md" />
          <span className="text-sm font-semibold text-gray-900">Apporb</span>
          <span className="text-gray-300 mx-1">/</span>
          <span className="text-sm text-gray-500">Documentation</span>
        </header>

        <main className="flex-1 max-w-2xl px-10 py-8">
          {children}
        </main>
      </div>
    </div>
  );
}
